import { Modifier, EditorState, SelectionState } from 'draft-js';

import { fetchSmartLinkTitle } from '../utils/fetchSmartLinkTitle';
import { smartLinksSchema } from '../smartLinksPlugin';

let isTransforming = [];

export default function addDocName(editorState: EditorState, callback: Function): EditorState {
  const contentState = editorState.getCurrentContent();

  const transformName = entity => {
    fetchSmartLinkTitle(entity.linkHref).then(response => {
      if (!response.data?.name) {
        const test = contentState.mergeEntityData(entity.entityKey, { transformed: 'attempted' });
        callback(EditorState.push(editorState, test, 'insert-fragment'));
        return;
      }

      const entityType = entity.entity.getType();
      const contentStateWithEntity = editorState.getCurrentContent().createEntity(entityType, 'IMMUTABLE', {
        href: entity.linkHref,
        transformed: 'complete',
      });
      const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      const selection = SelectionState.createEmpty(entity.blockKey)
        .set('anchorOffset', entity.start)
        .set('focusOffset', entity.end);

      let replaced = Modifier.replaceText(
        contentState,
        selection,
        ` ${response.data.name}`,
        contentState.getBlockForKey(entity.blockKey).getInlineStyleAt(),
        entityKey
      );

      replaced = Modifier.insertText(replaced, replaced.getSelectionAfter(), ' ');

      isTransforming = isTransforming.filter(href => href !== entity.linkHref);
      const newEditorState = EditorState.push(editorState, replaced, 'insert-fragment');
      callback(EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter()));
    });
  };

  contentState.getBlocksAsArray().forEach(block => {
    let selectedEntity = null;
    block.findEntityRanges(
      character => {
        if (character.getEntity() !== null) {
          const entityKey = character.getEntity();
          const entity = contentState.getEntity(entityKey);
          const { href, transformed } = entity.getData();
          const entityType = entity.getType();
          const blockText = block.getText();

          const entityTypes = smartLinksSchema.map(m => m.entityType);
          if (
            entityTypes.includes(entityType) &&
            blockText.includes(href) &&
            !transformed &&
            !isTransforming.includes(href)
          ) {
            isTransforming.push(href);
            selectedEntity = {
              entityKey,
              blockKey: block.getKey(),
              entity: contentState.getEntity(character.getEntity()),
              linkHref: href,
            };
            return true;
          }
        }
        return false;
      },
      (start, end) => {
        // We are using this function because in most of the scenarios when using entity,
        // we need start and end position of the entity as well which we only get here
        // entitiesToTransform.push({ ...selectedEntity, start, end });
        transformName({ ...selectedEntity, start, end });
      }
    );
  });
}
